












































import { Vue, Component } from 'vue-property-decorator'
import { ExStore } from 'vuex'
import ky from 'ky'
import { ValidationErrorResponse } from '@/api/types'

@Component
export default class PasswordChange extends Vue {
  $store!: ExStore
  password = ''
  passwordConfirm = ''
  error: ValidationErrorResponse = {
    password: []
  }

  handleChangePassword() {
    this.resetError()
  }

  resetError() {
    this.error = {
      password: []
    }
  }

  checkConfirmPassword() {
    const valid = this.password === this.passwordConfirm
    if (!valid) {
      this.error = {
        password: ['２つのパスワードが一致しません']
      }
    }
    return valid
  }

  async handleSubmitPassword() {
    const password = this.password
    if (!this.checkConfirmPassword()) return
    try {
      await this.$store.dispatch('user/changePassword', { password })
      const user = this.$store.getters['user/userInfo']
      this.$store.commit('user/updateUserInfo', {
        ...user,
        requireChangePassword: false
      })
      this.$router.push({ name: 'Home' })
    } catch (e) {
      if (e instanceof ky.HTTPError) {
        const errors = await e.response.json()
        this.error = errors
        return
      }
      console.error(e)
    }
  }
}
